<template>
  <div>
    <div class="container">
      <div class="my-service-container">
        <div class="row">
          <p class="about-me-sub-title">My Services</p>
          <h2 class="about-me-main-title">Life is about creating memories</h2>
          <p class="paragraph">
            Although photography is one of the easiest tasks in the world, it takes a lot
            of work to make it truly effective.
          </p>
        </div>

        <div class="col-12">
          <div class="row my-4">
            <!-- Card start -->
            <div class="col-lg-3 col-md-6 col-sm-12 px-4 mt-4">
              <div class="card py-4" style="width: 100%">
                <div class="card-body">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="44"
                    height="45"
                    viewBox="0 0 54 55"
                    fill="none"
                    class="mx-auto"
                  >
                    <path
                      d="M16.7887 0.5C16.3054 0.509721 15.8346 0.655065 15.43 0.919456C15.0253 1.18385 14.7031 1.55664 14.5002 1.99531L14.6014 1.79954L7.56704 13.4886L7.51641 13.5865C7.34511 13.9694 7.26308 14.3863 7.27653 14.8055C7.28998 15.2248 7.39855 15.6355 7.59404 16.0067C7.91471 16.5775 8.43349 17.011 9.05223 17.2252L3.93171 26.8654L3.90471 26.9667C3.75124 27.3534 3.67922 27.7677 3.69316 28.1835C3.7071 28.5994 3.8067 29.0079 3.98572 29.3835C4.275 29.9663 4.7636 30.4262 5.36289 30.6796L0.245753 40.3705L0.21875 40.4717C0.0651383 40.8588 -0.00752335 41.2733 0.00524859 41.6895C0.0180205 42.1058 0.115955 42.515 0.293009 42.8919C0.647428 43.648 1.50816 44.3872 2.56129 44.3872H11.7053V52.8055C11.7044 53.0283 11.7476 53.249 11.8325 53.455C11.9173 53.661 12.0421 53.8482 12.1996 54.0057C12.3571 54.1632 12.5443 54.288 12.7503 54.3728C12.9563 54.4577 13.177 54.5009 13.3998 54.5H20.154C20.3768 54.5009 20.5975 54.4577 20.8035 54.3728C21.0095 54.288 21.1966 54.1632 21.3541 54.0057C21.5117 53.8482 21.6364 53.661 21.7213 53.455C21.8061 53.249 21.8493 53.0283 21.8484 52.8055V44.3872H30.9925L31.0296 44.3805H33.7806V52.8055C33.7788 53.2508 33.953 53.6788 34.2653 53.9962C34.5777 54.3136 35.0028 54.4946 35.448 54.5H42.1989C42.4216 54.5009 42.6424 54.4577 42.8484 54.3728C43.0543 54.288 43.2415 54.1632 43.399 54.0057C43.5565 53.8482 43.6813 53.661 43.7662 53.455C43.851 53.249 43.8942 53.0283 43.8933 52.8055V44.3805H51.4475C51.8762 44.3764 52.2974 44.2672 52.6741 44.0624C53.0507 43.8576 53.3713 43.5635 53.6078 43.2058C53.8418 42.8362 53.9749 42.4117 53.9938 41.9747C54.0128 41.5376 53.9169 41.1033 53.7158 40.7148L53.6888 40.6675L49.4763 33.9369C49.8777 33.737 50.2138 33.4267 50.445 33.0424C50.6653 32.6315 50.7682 32.1678 50.7426 31.7023C50.717 31.2367 50.5638 30.7872 50.2999 30.4029L50.3741 30.4771L46.1886 23.7938C46.5879 23.5805 46.9242 23.2663 47.1641 22.8824C47.3807 22.5084 47.5006 22.0863 47.513 21.6543C47.5254 21.2223 47.4298 20.794 47.235 20.4082L47.208 20.3644L40.9803 9.74865C40.7615 9.37849 40.45 9.07174 40.0765 8.85865C39.703 8.64557 39.2804 8.5335 38.8504 8.5335C38.4204 8.5335 37.9979 8.64557 37.6244 8.85865C37.2509 9.07174 36.9394 9.37849 36.7206 9.74865L30.4659 20.3644L30.4423 20.4082C30.1583 21.0057 30.1097 21.6882 30.3061 22.3199C30.5025 22.9516 30.9295 23.4862 31.5022 23.8174L29.6625 26.754L24.5927 17.1915C24.9301 17.0577 25.2362 16.8556 25.4916 16.5978C25.7471 16.3399 25.9464 16.032 26.0771 15.6934C26.2077 15.3547 26.2668 14.9927 26.2507 14.6301C26.2346 14.2675 26.1435 13.9122 25.9833 13.5865L25.9563 13.5325L19.057 1.82654C18.8263 1.42831 18.4957 1.09712 18.098 0.865669C17.7002 0.634218 17.2489 0.510508 16.7887 0.506751V0.5ZM16.8123 4.68552L22.3176 13.9814H11.2125L16.8123 4.68552ZM38.8403 12.8135L43.4984 20.7323H34.1789L38.8403 12.8135ZM12.7719 17.3771H20.8831L26.2297 27.4899H7.41852L12.7719 17.3771ZM35.2928 24.1279H42.4149L46.6308 30.872H31.0701L35.2928 24.1279ZM9.08598 30.8788H24.5117L27.077 35.7563L29.8212 40.9916H3.73256L9.08598 30.8788ZM32.0152 34.2407H45.6958L49.9016 40.9916H33.4261C33.3924 40.8194 33.4025 40.6439 33.335 40.4717L33.308 40.3705V40.3637L30.9688 35.9082L32.0152 34.2407ZM37.1459 44.3805H40.5348V51.1313H37.1459V44.3805ZM15.0942 44.3872H18.4562V51.1313H15.0909V44.3872H15.0942Z"
                      fill="#0DC58D"
                    />
                  </svg>
                  <p class="card-text mt-3">
                    Wildlife <br />
                    Photography
                  </p>
                </div>
              </div>
            </div>
            <!-- Card end -->

            <!-- Card start -->
            <div class="col-lg-3 col-md-6 col-sm-12 px-4 mt-4">
              <div class="card py-4" style="width: 100%">
                <div class="card-body">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="44"
                    height="45"
                    viewBox="0 0 54 55"
                    fill="none"
                    class="mx-auto"
                  >
                    <path
                      d="M53.325 38.3V46.4001C53.325 50.4959 49.9959 53.8251 45.9 53.8251H37.8C36.6822 53.8251 35.775 52.9179 35.775 51.8C35.775 50.6823 36.6822 49.7751 37.8 49.7751H45.9C47.7603 49.7751 49.275 48.2603 49.275 46.4001V38.3C49.275 37.1823 50.1822 36.2751 51.3 36.2751C52.4178 36.2751 53.325 37.1823 53.325 38.3ZM16.2 49.7751H8.1C6.2397 49.7751 4.725 48.2603 4.725 46.4001V38.3C4.725 37.1823 3.8178 36.2751 2.7 36.2751C1.5822 36.2751 0.675003 37.1823 0.675003 38.3V46.4001C0.675003 50.4959 4.0041 53.8251 8.1 53.8251H16.2C17.3178 53.8251 18.225 52.9179 18.225 51.8C18.225 50.6823 17.3178 49.7751 16.2 49.7751ZM45.9 1.17505H37.8C36.6822 1.17505 35.775 2.08225 35.775 3.20005C35.775 4.31785 36.6822 5.22505 37.8 5.22505H45.9C47.7603 5.22505 49.275 6.73975 49.275 8.60005V16.7C49.275 17.8178 50.1822 18.725 51.3 18.725C52.4178 18.725 53.325 17.8178 53.325 16.7V8.60005C53.325 4.50415 49.9959 1.17505 45.9 1.17505ZM2.7 18.725C3.8178 18.725 4.725 17.8178 4.725 16.7V8.60005C4.725 6.73975 6.2397 5.22505 8.1 5.22505H16.2C17.3178 5.22505 18.225 4.31785 18.225 3.20005C18.225 2.08225 17.3178 1.17505 16.2 1.17505H8.1C4.0041 1.17505 0.675003 4.50415 0.675003 8.60005V16.7C0.675003 17.8178 1.5822 18.725 2.7 18.725ZM16.875 19.4C16.875 13.8164 21.4191 9.27505 27 9.27505C32.5809 9.27505 37.125 13.8164 37.125 19.4C37.125 22.3944 35.7939 25.0592 33.723 26.9141C38.502 28.9823 42.1929 33.1593 43.4376 38.5134C43.7724 39.9552 43.4376 41.4428 42.5223 42.5957C41.6232 43.727 40.2813 44.375 38.8368 44.375H15.1632C13.7187 44.375 12.3768 43.727 11.4777 42.5957C10.5624 41.4428 10.2276 39.9552 10.5624 38.516C11.8071 33.1619 15.498 28.9851 20.277 26.9169C18.2034 25.062 16.8723 22.3971 16.8723 19.4028L16.875 19.4ZM27 29.525C21.0006 29.525 15.8652 33.5993 14.5071 39.4314C14.4315 39.7581 14.58 39.9902 14.6475 40.0739C14.7366 40.1873 14.9013 40.3251 15.1632 40.3251H38.8368C39.1014 40.3251 39.2634 40.19 39.3525 40.0739C39.4173 39.9902 39.5685 39.758 39.4929 39.4286C38.1348 33.5966 32.9994 29.525 27 29.525ZM20.925 19.4C20.925 22.7507 23.652 25.475 27 25.475C30.348 25.475 33.075 22.7507 33.075 19.4C33.075 16.0493 30.348 13.325 27 13.325C23.652 13.325 20.925 16.0493 20.925 19.4Z"
                      fill="#107DFC"
                    />
                  </svg>
                  <p class="card-text mt-3">
                    Portrait <br />
                    Photography
                  </p>
                </div>
              </div>
            </div>
            <!-- Card end -->

            <!-- Card start -->
            <div class="col-lg-3 col-md-6 col-sm-12 px-4 mt-4">
              <div class="card py-4" style="width: 100%">
                <div class="card-body">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="44"
                    height="45"
                    viewBox="0 0 54 55"
                    fill="none"
                    class="mx-auto"
                  >
                    <path
                      d="M42.75 32V27.5H38.25V14H33.75V5H20.25V14H15.75V27.5H11.25V45.5H4.5V50H49.5V45.5H42.75V32ZM24.75 9.5H29.25V14H24.75V9.5ZM33.75 18.5C33.75 19.0967 33.5129 19.669 33.091 20.091C32.669 20.5129 32.0967 20.75 31.5 20.75C30.9033 20.75 30.331 20.5129 29.909 20.091C29.4871 19.669 29.25 19.0967 29.25 18.5H33.75ZM24.75 18.5C24.75 19.0967 24.5129 19.669 24.091 20.091C23.669 20.5129 23.0967 20.75 22.5 20.75C21.9033 20.75 21.331 20.5129 20.909 20.091C20.4871 19.669 20.25 19.0967 20.25 18.5H24.75ZM20.25 24.845C21.3895 25.2689 22.6245 25.3671 23.8167 25.1286C25.0089 24.8902 26.1112 24.3245 27 23.495C27.8888 24.3245 28.9911 24.8902 30.1833 25.1286C31.3755 25.3671 32.6105 25.2689 33.75 24.845V27.5H20.25V24.845ZM38.25 32C38.25 32.5967 38.0129 33.169 37.591 33.591C37.169 34.0129 36.5967 34.25 36 34.25C35.4033 34.25 34.831 34.0129 34.409 33.591C33.9871 33.169 33.75 32.5967 33.75 32H38.25ZM29.25 32C29.25 32.5967 29.0129 33.169 28.591 33.591C28.169 34.0129 27.5967 34.25 27 34.25C26.4033 34.25 25.831 34.0129 25.409 33.591C24.9871 33.169 24.75 32.5967 24.75 32H29.25ZM20.25 32C20.25 32.5967 20.0129 33.169 19.591 33.591C19.169 34.0129 18.5967 34.25 18 34.25C17.4033 34.25 16.831 34.0129 16.409 33.591C15.9871 33.169 15.75 32.5967 15.75 32H20.25ZM15.75 45.5V38.345C16.8895 38.7689 18.1245 38.8671 19.3167 38.6286C20.5089 38.3902 21.6112 37.8245 22.5 36.995C23.7376 38.1019 25.3397 38.7138 27 38.7138C28.6603 38.7138 30.2624 38.1019 31.5 36.995C32.3888 37.8245 33.4911 38.3902 34.6833 38.6286C35.8755 38.8671 37.1105 38.7689 38.25 38.345V45.5H15.75Z"
                      fill="#FD9419"
                    />
                  </svg>
                  <p class="card-text mt-3">
                    Event <br />
                    Photography
                  </p>
                </div>
              </div>
            </div>
            <!-- Card end -->

            <!-- Card start -->
            <div class="col-lg-3 col-md-6 col-sm-12 px-4 mt-4">
              <div class="card py-4" style="width: 100%">
                <div class="card-body">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="44"
                    height="45"
                    viewBox="0 0 54 55"
                    fill="none"
                    class="mx-auto"
                  >
                    <path
                      d="M53.0356 31.9356L51.4688 28.0189V15.6875C51.4688 15.0656 51.127 14.4936 50.5778 14.1999L26.9528 1.5437C26.4549 1.27792 25.8567 1.27792 25.3589 1.5437L1.73391 14.1999C1.18631 14.4936 0.84375 15.0656 0.84375 15.6875C0.84375 16.3093 1.18631 16.8814 1.73475 17.175L12.6562 23.0256V30.875C12.6562 30.9965 12.6706 31.1146 12.6951 31.2293C13.0967 35.0364 19.8501 36.7812 26.1562 36.7812C32.4624 36.7812 39.2158 35.0364 39.6174 31.2293C39.6419 31.1146 39.6562 30.9965 39.6562 30.875V23.0256L48.0938 18.5056V28.0189L46.5269 31.9364C46.3193 32.4562 46.3826 33.0451 46.6965 33.5092C47.0104 33.9724 47.5335 34.25 48.0938 34.25H51.4688C52.029 34.25 52.5521 33.9724 52.866 33.5083C53.1799 33.0451 53.244 32.4562 53.0356 31.9356ZM16.0279 19.0937C16.2388 18.3875 19.672 16.5312 26.1562 16.5312C32.6405 16.5312 36.0737 18.3875 36.2812 19.0625V26.7954C33.6428 25.5568 29.8215 24.9687 26.1562 24.9687C22.491 24.9687 18.668 25.5568 16.0304 26.7963L16.0279 19.0937ZM26.1562 33.4062C19.6712 33.4062 16.2388 31.5508 16.0279 30.9053C16.2397 30.2 19.6712 28.3437 26.1562 28.3437C32.5519 28.3437 35.9783 30.1485 36.2737 30.875C35.9783 31.6014 32.5519 33.4062 26.1562 33.4062ZM26.1562 13.1562C19.6543 13.1562 12.6562 15.004 12.6562 19.0625V19.1966L6.10453 15.6875L26.1562 4.9457L46.2071 15.6875L39.6562 19.1966V19.0625C39.6562 15.004 32.6582 13.1562 26.1562 13.1562ZM38.8125 37.625C38.5779 37.625 38.3501 37.6545 38.1257 37.6959C30.1632 38.7235 22.0919 38.7219 14.1235 37.6883L13.7101 37.6376C13.6401 37.6292 13.57 37.625 13.5 37.625C10.6144 37.625 8.4375 40.8894 8.4375 45.2187C8.4375 49.548 10.6144 52.8125 13.5 52.8125C13.6156 52.8125 13.8552 52.8125 14.1421 52.7298C14.1455 52.7289 14.148 52.7281 14.1514 52.7273L14.2543 52.7138C22.1122 51.708 30.0788 51.7046 37.9384 52.7003C38.2219 52.7694 38.5121 52.8125 38.8125 52.8125C41.699 52.8125 43.875 49.548 43.875 45.2187C43.875 40.8894 41.699 37.625 38.8125 37.625ZM26.0963 48.5828C25.6812 47.8723 25.3125 46.7265 25.3125 45.2187C25.3125 43.7008 25.6871 42.5499 26.1065 41.8395C28.863 41.8412 31.6178 41.7138 34.3659 41.4801C33.9719 42.5719 33.75 43.8409 33.75 45.2187C33.75 46.589 33.9694 47.8521 34.3592 48.9388C31.6103 48.7068 28.8537 48.5811 26.0963 48.5828ZM13.8308 49.3666L13.4013 49.4206C12.8672 49.2493 11.8125 47.7896 11.8125 45.2187C11.8125 42.5778 12.9254 41.108 13.4443 41.0059L13.6966 41.0371C16.6101 41.4151 19.5387 41.6522 22.4716 41.7636C22.1273 42.8124 21.9375 43.9919 21.9375 45.2187C21.9375 46.4405 22.1257 47.6141 22.4665 48.6595C19.5801 48.7684 16.6978 48.9996 13.8308 49.3666ZM38.8125 49.4375C38.3231 49.4375 37.125 47.9592 37.125 45.2187C37.125 42.4782 38.3231 41 38.8125 41C39.3019 41 40.5 42.4782 40.5 45.2187C40.5 47.9592 39.3019 49.4375 38.8125 49.4375Z"
                      fill="#FC1010"
                    />
                  </svg>
                  <p class="card-text mt-3">
                    Graduation <br />
                    Photography
                  </p>
                </div>
              </div>
            </div>
            <!-- Card end -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyService",
};
</script>

<style scoped>
.about-me-sub-title {
  color: #0074fc;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
}
.about-me-main-title {
  color: #000;
  font-family: "Open Sans";
  font-size: 50px;
  font-style: normal;
  font-weight: 400;
  line-height: 58px;
}

.paragraph {
  color: #5c5c5c;
  text-align: center;
  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding: 10px 60px;
}

.my-service-container {
  margin: 40px 50px;
}

.card {
  border-radius: 10px;
  background: #fff;
  box-shadow: 16px 16px 35px 10px rgba(0, 0, 0, 0.15);
  border: none;
}

.card-text {
  color: #1a1a1a;
  text-align: center;
  font-family: "Open Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
}

@media screen and (min-width: 280px) {
  .my-service-container {
    margin: 100px 30px;
  }

  .paragraph {
    padding: 10px 10px;
  }

  .about-me-main-title {
    font-size: 32px;
  }
}

@media screen and (min-width: 390px) {
  .my-service-container {
    margin: 100px 50px;
  }

  .paragraph {
    padding: 10px 10px;
  }

  .about-me-main-title {
    font-size: 47px;
  }
}

@media screen and (min-width: 768px) {
  .my-service-container {
    margin: 160px 50px;
  }

  .paragraph {
    padding: 10px 60px;
  }

  .about-me-main-title {
    font-size: 50px;
  }
}
</style>
